import { TFunction } from 'i18next';
import {
  scheduledFilter,
  ScheduledFilterPreset
} from 'v5/core/standard-date-filter/scheduled-filter';
import { FilterDateConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createProductionDateFilterConfig(
  t: TFunction<'core'>
): FilterDateConfig<ScheduledFilterPreset> {
  return scheduledFilter.createFilterConfig(
    t('core_fields.production_date'),
    t
  );
}
